<template>
  <div class="payment">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col cols="2" style="display: flex">
          <v-app-bar-nav-icon @click="navBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="8" class="d-flex justify-center">
          <div>
            <v-toolbar-title class="header-title1" v-if="$store.state.store != null && $store.state.store.info != null">
              {{ $store.getters.storeName }}
            </v-toolbar-title>
            <v-toolbar-title class="header-title2"
              >{{ $t($store.getters.orderFrom) }}
              <span class="header-title2-feature">{{ $t("payment") }}</span></v-toolbar-title
            >
          </div>
        </v-col>

        <v-col cols="2" align-self="end" style="text-align: right"> </v-col>
      </v-row>
    </v-app-bar>

    <v-container v-if="$store.state.store != null" class="mt-n3">
      <input id="hppResponseId" @change="onHppResponseChange" style="display:none;" />

      <div v-if="merchant == 'globalPay' && globalPay.confirmed && !sendFailed" class="pay-amount">
        {{ ($store.state.order.total + $store.state.order.tips) | currency }}
      </div>

      <iframe
        id="iframeId"
        :style="{
          display: merchant === 'globalPay' && globalPay.confirmed && !sendFailed ? 'block' : 'none',
        }"
      ></iframe>

      <div
        v-if="(merchant == 'globalPay' && !globalPay.confirmed) || merchant == 'stripe' || sendFailed"
        class="order-content"
      >
        <cart :currentRouteName="$router.currentRoute.name"></cart>

        <div class="order-login-box mt-3" v-if="$store.state.order.login != null">
          <div class="t-title">
            {{
              $store.state.order.login.isMember != null && $store.state.order.login.isMember
                ? $t("member")
                : $t("guest")
            }}
          </div>
          <div v-if="$store.state.order.login.name != ''">
            {{ $store.state.order.login.name }}
          </div>
          <div v-if="$store.state.order.login.phone1 != ''">
            {{ $store.state.order.login.phone1 }}
          </div>
        </div>

        <div
          class="mt-3"
          v-if="
            sendFailed &&
              (merchant == 'globalPay' || (merchant == 'stripe' && !stripe.preAuthorize)) &&
              $store.state.order.payAmount > 0 &&
              $store.state.order.payData != null &&
              $store.state.order.payData.orderId != null
          "
        >
          <v-row>
            <v-col>
              <span class="order-paid-data-title">PAYMENT ORDER ID :</span><br />
              <span class="order-paid-data-value">{{ $store.state.order.payData.orderId }}</span>
            </v-col>
          </v-row>
        </div>

        <div class="mt-3" v-if="!sendFailed && $store.state.order.orderType == $store.state.OT_TAKEOUT">
          <v-row>
            <v-col>
              <span class="takeout-address-title">{{ $t("pickup_address") }}</span
              ><br />
              <span class="takeout-address">{{ storeAddressString }}</span>
            </v-col>
          </v-row>

          <v-row
            v-if="!sendFailed && !$store.getters.checkoutPickupTimeIgnored && $store.state.order.pickupTime != null"
          >
            <v-col>
              <span class="schedule-time-title">{{ $t("checkout.pickup_at") }}</span
              ><br />
              <span class="schedule-time">
                {{ toLocaleString($store.state.order.pickupTime) }}

                <span v-if="!$store.getters.storeTimeZoneMatched && $store.getters.storeTimeZoneAbbrev != ''">
                  ({{ $store.getters.storeTimeZoneAbbrev }})
                </span></span
              >
            </v-col>
          </v-row>
        </div>

        <div v-if="$store.state.order.orderType == $store.state.OT_DELIVERY" class="mt-3">
          <v-row v-if="$store.state.order.address != null">
            <v-col>
              <span class="delivery-address-title">{{ $t("delivery_address") }}</span
              ><br />
              <span class="delivery-address">{{ deliveryAddressString }}</span>
              <div
                v-if="
                  $store.state.order.address.phone1 !== undefined &&
                    $store.state.order.address.phone1 != null &&
                    $store.state.order.address.phone1 != ''
                "
              >
                {{ $store.state.order.address.phone1 }}
              </div>
              <div
                v-if="
                  $store.state.order.address.remark !== undefined &&
                    $store.state.order.address.remark != null &&
                    $store.state.order.address.remark != ''
                "
              >
                {{ $store.state.order.address.remark }}
              </div>
            </v-col>
          </v-row>

          <v-row v-if="!$store.getters.checkoutPickupTimeIgnored">
            <v-col>
              <span class="schedule-time-title">{{ $t("checkout.delivery_at") }}</span
              ><br />
              <span v-if="$store.state.order.deliveryTime != null" class="schedule-time"
                >{{ toLocaleString($store.state.order.deliveryTime) }}
                <span v-if="$store.state.order.deliveryTimeTo != null">
                  - {{ toLocaleTimeString($store.state.order.deliveryTimeTo) }}
                </span>

                <span v-if="!$store.getters.storeTimeZoneMatched && $store.getters.storeTimeZoneAbbrev != ''">
                  ({{ $store.getters.storeTimeZoneAbbrev }})
                </span>
              </span>
              <span v-else class="schedule-time">ASAP</span>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-show="stripePaymentVisible" class="card-form mt-3">
        <div class="accent--text font-weight-bold ">
          {{ $t("payment") }}
        </div>

        <v-radio-group v-model="stripe.cardSelected" class="card-group mt-0">
          <div class="d-flex" v-for="card in stripe.savedCards" :key="card.id">
            <v-radio :value="card.id" class="card-item">
              <template v-slot:label>
                <div class="card-item-label">
                  {{ card.card }} Ending in {{ card.last4 }} Expiry: {{ card.exp_month }}/{{ card.exp_year }}
                </div>
              </template>
            </v-radio>
            <v-icon right color="warning" class="mb-3" @click="removeCard(card.id)">
              mdi-delete
            </v-icon>
          </div>
          <v-radio value="new-card" class="card-item">
            <template v-slot:label>
              <div id="card-element" class="card-field"></div>
            </template>
          </v-radio>
          <!--           <div v-show="stripe.cardSelected == 'new-card'" class="card-save pl-12">
            <v-switch color="secondary" v-model="stripe.saveCard" :ripple="false" label="Save card details"></v-switch>
            <div class="card-save-message">
              These card details can be stored so that subsequent transactions do not require you to enter your card
              details. To avail of this service please tick the checkbox.
            </div>
          </div> -->
        </v-radio-group>

        <v-switch
          color="secondary"
          class="stripe-save-card"
          v-model="stripe.saveCard"
          :ripple="false"
          dense
          label="Save card details"
        ></v-switch>

        <v-btn class="stripe-alipay" v-if="stripeAlipayVisible" @click.once="alipay()">Ali-Play</v-btn>

        <v-img class="stripe-powered-by" src="@/assets/imgs/powered-by-stripe.svg" width="120" x-height="50" />

        <!-- <div class="warning--text ml-13 mt-4" id="card-errors" role="alert"></div> -->
      </div>

      <div
        class="terms-of-use-box"
        v-if="!sendFailed && ((merchant == 'globalPay' && !globalPay.confirmed) || merchant == 'stripe')"
      >
        <div class="accept-policy">
          By placing your order, you confirm that you read and accept these
          <span class="terms-of-use-text" @click="openTermsOfUse">terms of use</span>.
        </div>
        <!--         <div class="terms-of-use">
          <span class="terms-of-use-text" @click="openTermsOfUse">Terms of use</span>
        </div> -->
      </div>
    </v-container>

    <v-footer
      fixed
      :class="{
        '' /**desktop-mode-padding-left */: $vuetify.breakpoint.mdAndUp,
      }"
    >
      <!--       <div v-if="(merchant == 'globalPay' && !globalPay.confirmed) || (merchant == 'stripe' && !sendFailed)">
        <div class="merchant-info">
          <div class="store-name">{{ $store.getters.storeName }}</div>
          <div class="store-address">{{ storeAddressString }}</div>
        </div>
        <div class="accept-policy">By placing your order, you confirm that you read and accept these terms of use.</div>
        <div class="terms-of-use">
          <span class="terms-of-use-text" @click="openTermsOfUse">Terms of use</span>
        </div>
      </div> -->

      <div v-if="payFailedMessage != ''" class="pay-failed-text">
        {{ payFailedMessage }}
      </div>

      <v-btn
        id="payButtonId"
        v-if="merchant == 'globalPay' && !globalPay.confirmed"
        block
        tile
        class="confirm-button"
        @click.capture="confirmGp"
        >{{ $t("payment.confirm") }}</v-btn
      >
      <v-btn
        v-else-if="merchant == 'stripe' && !sendFailed"
        block
        tile
        class="confirm-button"
        @click="confirmStripe"
        :disabled="stripeConfirmButtonDisabled"
        >{{ $t("payment.confirm") }}</v-btn
      >

      <!-- <button class="card-submit" @click.once="confirmStripe">Submit Payment</button> -->
      <!-- <button block tile color="info" id="payButtonId" @click="confirmGp">{{ $t("payment.confirm") }}</button> -->

      <div v-if="sendFailed">
        <div class="send-failed-text" v-html="sendFailedMessage">
          <!--           {{
            $t("payment.paid_but_fails_send_order", {
              store_tel: $store.getters.storeTel,
            })
          }} -->
        </div>
        <v-btn block tile color="info" class="resend-button infoText--text" @click="sendOrder(null)">
          {{ $t("payment.resend_order") }}
        </v-btn>
      </div>
    </v-footer>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <PaymentTermsOfUseDialog ref="termsOfUseDialog"></PaymentTermsOfUseDialog>
  </div>
</template>

<script>
import PaymentTermsOfUseDialog from "@/dialogs/PaymentTermsOfUseDialog";
import Cart from "@/components/Cart.vue";
import { loadStripe } from "@stripe/stripe-js";

export default {
  components: {
    PaymentTermsOfUseDialog,
    Cart,
  },

  data() {
    return {
      refreshing: false,

      merchant: "",
      payerId: "",

      globalPay: {
        ready: false,
        confirmed: false,
      },

      stripe: {
        key: "",
        paymentKey: "",
        paymentKey2: "",
        res: null,
        saveCard: true,
        savedCards: [],
        newCardValid: false,
        cardElement: null,
        cardSelected: null,
        ready: false,
        confirmed: false,
        preAuthorize: false,
      },

      sendFailed: false,
      sendFailedSaved: false,
      payFailedMessage: "",
    };
  },

  mounted() {
    //
  },

  activated() {
    console.log("payment activated");

    this.$store.state.order.payData = {};

    this.merchant = "";
    this.payerId = "";
    this.globalPay.ready = false;
    this.globalPay.confirmed = false;

    this.stripe.ready = false;
    this.stripe.confirmed = false;
    this.stripe.preAuthorize = false;
    this.stripe.saveCard = this.sp_getSaveCard();
    this.stripe.savedCards = [];
    this.stripe.cardSelected = null;
    this.stripe.newCardValid = false;

    this.sendFailed = false;
    this.sendFailedSaved = false;

    //debug for send failed
    /*  
    this.sendFailed = true;
    this.sendFailedSaved = true;
    this.globalPay.confirmed = true;
    this.stripe.confirmed = true;
    */
    this.$store.state.cartKey++;

    console.log("order", this.$store.state.order);
    if (this.$route.params.merchant != null) {
      this.merchant = this.$route.params.merchant;
      if (this.merchant == "globalPayment") this.merchant = "globalPay";
      if (this.merchant == "globalPay") {
        this.gp_getPayerId().then(payerId => {
          this.payerId = payerId;
          this.initGP();
        });
      } else if (this.merchant == "stripe") {
        this.sp_getPayerId().then(payerId => {
          this.payerId = payerId;
          this.initStripe();
        });
      }
    }
  },

  computed: {
    sendFailedMessage() {
      if (this.merchant == "stripe" && this.stripe.preAuthorize)
        return this.$t("payment.pre_authorized_send_failed", { store_tel: this.$store.getters.storeTel });
      else return this.$t("payment.paid_but_fails_send_order", { store_tel: this.$store.getters.storeTel });
    },

    stripeConfirmButtonDisabled() {
      return (
        this.refreshing ||
        !this.stripe.ready ||
        this.stripe.cardSelected == null ||
        (this.stripe.cardSelected == "new-card" && (!this.stripe.newCardValid || this.stripe.confirmed))
      );
    },

    stripePaymentVisible() {
      return this.stripe.ready && !this.sendFailed;
    },

    stripeAlipayVisible() {
      return false; //this.$devEnv;
    },
  },

  watch: {
    "stripe.cardSelected"() {
      console.log("Stripe/Card changed");

      this.payFailedMessage = "";
    },
  },

  methods: {
    // global payment
    initGP() {      
      this.gp_getRequest({ amount: this.$store.state.order.total + this.$store.state.order.tips, currency: this.$store.state.order.currency, payer_id: this.payerId, order_id: "" })
        .then(resp => {
          var jsonData = resp;
          var jsonReqEndpoint = jsonData.data;
          var jsonCallBackUrl = jsonData.call_back_url;
          this.$RealexHpp.setHppUrl(jsonData.service_url);

          this.$RealexHpp.embedded.init("payButtonId", "iframeId", jsonCallBackUrl, jsonReqEndpoint);

          this.globalPay.ready = true;
        })
        .catch(err => {
          console.log(err);
        });
    },

    confirmGp() {
      if (!this.globalPay.ready) return;
      this.globalPay.confirmed = true;
      this.$root.messageDialog("", "", this.$t("payment_message"), {
        timer: 5000,
      });
    },

    onHppResponseChange(event) {
      console.log("onHppResponseChange");

      var jsonData = JSON.parse(event.srcElement.textContent);
      console.log(jsonData);

      var res = jsonData.result;
      var resp_code = jsonData.response_code;

      if (res == "ok" && resp_code == "00") {
        this.refreshing = true;
        let orderId = jsonData.order_id;
        this.gp_getStatus(orderId)
          .then(response => {
            console.log(response);

            if (response.result != null) {
              let result = response.result;
              if (result == "ok") {
                let payData = {
                  merchant: "globalPay",
                  orderId: response.data.ORDER_ID,
                  data: response.data,
                };
                //let payData = { merchant: "globalPay", ORDER_ID: response.data.ORDER_ID, CARDDIGITS: response.data.CARDDIGITS, CARDTYPE: response.data.CARDTYPE };
                this.sendOrder(payData);

                if (response.data != null) {
                  if (response.data.SAVED_PAYER_REF != null) {
                    this.gp_setPayerId(response.data.SAVED_PAYER_REF);
                  }
                }
              } else {
                this.setPayFailed();
              }
            } else {
              this.setPayFailed();
            }
          })
          .finally(() => {
            this.refreshing = false;
          });
      } else {
        this.setPayFailed(jsonData.message);
        this.refreshing = false;
      }
    },
    // global payment end

    // stripe payment
    initStripe() {
      var errorElement = document.getElementById("card-errors");
      if (errorElement != null) errorElement.textContent = "";
      this.payFailedMessage = "";

      this.refreshing = true;
      this.sp_getRequest({
        amount: this.$store.state.order.total + this.$store.state.order.tips,
        currency: this.$store.state.order.currency,
        payerId: this.payerId,
        withholding: this.$store.state.order.deliveryWithhold,
      })
        .then(async rpdata => {
          console.log("stripe data", rpdata);
          if (rpdata.result == "ok") {
            this.stripe.key = rpdata.data.key;
            this.stripe.paymentKey = rpdata.data.payment_key;
            this.stripe.paymentKey2 = rpdata.data.payment_key2;
            this.stripe.preAuthorize = rpdata.data.pre_auth != null && rpdata.data.pre_auth;

            this.stripe.res = await loadStripe(this.stripe.key, {
              stripeAccount: rpdata.data.sub_account,
            });

            if (rpdata.data.cards) {
              this.stripe.savedCards = rpdata.data.cards;
            }
            if (rpdata.data.payer_id) {
              this.payerId = rpdata.data.payer_id;
              this.sp_setPayerId(this.payerId);
            }
            if (this.stripe.savedCards.length > 0) {
              this.stripe.cardSelected = this.stripe.savedCards[0].id;
            } else {
              this.stripe.cardSelected = "new-card";
            }
            this.createStripeElements();

            this.stripe.ready = true;
            console.log("stripe", this.stripe);
          }
          this.refreshing = false;
        })
        .catch(err => {
          this.refreshing = false;
          console.log(err);
        }); // eslint-disable-line
    },

    removeCard(cardId) {
      this.$root.confirmDialog(this.$t("confirm"), "", this.$t("confirm_remove_card_question")).then(resp => {
        if (resp) {
          this.refreshing = true;
          this.sp_removeCard(cardId)
            .then(rpdata => {
              if (rpdata.result == "ok") {
                this.stripe.savedCards = this.stripe.savedCards.filter(value => value.id != cardId);
              }
              this.refreshing = false;
            })
            .catch(err => {
              this.refreshing = false;
              console.log(err);
            });
        }
      });
    },

    alipay() {
      let returnUrl = this.$store.state.originUrl + "/#/menu-full";
      let obj;
      obj = {
        return_url: `${returnUrl}`,
      };
      this.stripe.res.confirmAlipayPayment(this.stripe.paymentKey2, obj).then(result => {
        console.log(result);
        if (result.error) {
          var errorElement = document.getElementById("card-errors");
          if (errorElement) errorElement.textContent = result.error.message;
          this.payFailedMessage = result.error.message;
          // } else if (result.paymentIntent.status === "succeeded") {
          //   console.log(result);
          //   this.verifyPayment(result.paymentIntent);
        }
      });
    },

    updateSaveCardStatus() {
      this.sp_setSaveCard(this.stripe.saveCard);
      if (!this.stripe.saveCard) this.sp_setPayerId("");
    },

    async confirmStripe(event) {
      console.log("confirming stripe");

      event.preventDefault();
      if (!this.stripe.ready) return;

      if (this.$store.getters.doorDashEnabled) {
        this.refreshing = true;
        let ddRes = await this.rest_doorDashValidate();
        this.refreshing = false;

        if (ddRes.result != "ok") {
          let errorMessage = ddRes.result;
          if (
            ddRes.data.field_errors != null &&
            Array.isArray(ddRes.data.field_errors) &&
            ddRes.data.field_errors.length > 0
          ) {
            errorMessage = ddRes.data.field_errors[0].field + " - " + ddRes.data.field_errors[0].error;
          }
          this.$root.messageDialog(this.$t("error"), "", errorMessage);
          return;
        }
      }

      this.$root.confirmDialog(this.$t("confirm_payment_title"), "", this.$t("payment_message")).then(resp => {
        if (resp) {
          this.stripe.confirmed = true;

          let obj;
          if (this.stripe.cardSelected == "new-card") {
            obj = {
              payment_method: { card: this.stripe.cardElement },
              setup_future_usage: "off_session",
            };
            this.refreshing = true;
            this.stripe.res
              .confirmCardPayment(this.stripe.paymentKey, obj)
              .then(this.stripe.cardElement)
              .then(result => {
                console.log(result);
                if (
                  result.paymentIntent != null &&
                  (result.paymentIntent.status === "succeeded" || result.paymentIntent.status === "requires_capture")
                ) {
                  let payData = {
                    merchant: "stripe",
                    orderId: result.paymentIntent.id,
                    preAuthorize: this.stripe.preAuthorize,
                  };
                  this.sendOrder(payData);

                  //this.updateSaveCardStatus();
                } else {
                  let errorMessage;
                  if (result.error) {
                    errorMessage = result.error.message;
                  } else {
                    errorMessage = this.$t("error_pay");
                  }
                  throw new Error(errorMessage);
                }
              })
              .catch(err => {
                var errorElement = document.getElementById("card-errors");
                if (errorElement != null) errorElement.textContent = err;
                this.payFailedMessage = err;

                console.log(err);
              })
              .finally(() => {
                this.refreshing = false;
                //this.stripe.confirmed = false;
              });
          } else {
            this.refreshing = true;
            this.sp_payBySavedCard({
              amount: this.$store.state.order.total + this.$store.state.order.tips,
              currency: this.$store.state.order.currency,
              payerId: this.payerId,
              cardId: this.stripe.cardSelected,
            })
              .then(rpdata => {
                console.log(rpdata);
                if (rpdata.result == "ok") {
                  let payData = {
                    merchant: "stripe",
                    orderId: rpdata.data.order_id,
                    preAuthorize: this.stripe.preAuthorize,
                    data: {
                      ORDER_ID: rpdata.data.order_id,
                      CARDDIGITS: rpdata.data.cardinfo.card_last4,
                      CARDTYPE: rpdata.data.cardinfo.card_type,
                    },
                  };
                  this.sendOrder(payData);

                  //this.updateSaveCardStatus();
                } else {
                  throw new Error(rpdata.result);
                }
              })
              .catch(err => {
                this.$root.messageDialog(this.$t("error_alert_title"), "", err);
                console.log(err);
              })
              .finally(() => {
                this.refreshing = false;
                //this.stripe.confirmed = false;
              });
          }
        }
      });
    },

    createStripeElements() {
      // Create an instance of Elements.
      var elements = this.stripe.res.elements();

      // Custom styling can be passed to options when creating an Element.
      // (Note that this demo uses a wider set of styles than the guide below.)
      var style = {
        base: {
          iconColor: "#666EE8",
          color: "#32325d",
          // lineHeight: "40px",
          fontWeight: 300,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };

      // Create an instance of the card Element.
      this.stripe.cardElement = elements.create("card", { style: style });

      // Add an instance of the card Element into the `card-element` <div>.
      this.stripe.cardElement.mount("#card-element");

      // Update radio when focused
      this.stripe.cardElement.on("focus", () => {
        this.stripe.cardSelected = "new-card";
      });
      // Handle real-time validation errors from the card Element.
      let that = this;
      this.stripe.cardElement.on("change", function(event) {
        console.log(event);
        that.stripe.newCardValid = event.complete;
        /*         if (event.complete) {
          that.stripe.newCardValid = event.complete;
        } */

        var displayError = document.getElementById("card-errors");
        if (event.error) {
          if (displayError) displayError.textContent = event.error.message;
          that.payFailedMessage = event.error.message;
        } else {
          if (displayError) displayError.textContent = "";
          that.payFailedMessage = "";
        }
      });
    },

    destoryStripeElements() {
      // card element still shown after dismount ??
      this.stripe.savedCards = [];
      this.stripe.cardElement.unmount();
      var elements = this.stripe.res.elements();
      elements.destoryElements();
    },
    // stripe payment end

    setPayFailed(errorMessage) {
      let message = this.$t("error_pay");
      if (errorMessage && errorMessage != "") {
        message = errorMessage;
      }

      this.$root.messageDialog(this.$t("error_alert_title"), "", message).then(resp => {
        if (resp) {
          this.navBack();
        }
      });
    },

    setSendFailed(message) {
      this.sendFailed = true;

      if (!this.sendFailedSaved) {
        this.addOrderHistory("SEND FAILED");
        this.sendFailedSaved = true;
      }

      if (message != null && message != "") {
        //message = this.$t("error_send_order");

        this.$root.messageDialog(this.$t("error_alert_title"), this.$t("error_send_order"), message);
      }
    },

    openTermsOfUse() {
      this.$refs.termsOfUseDialog.open();
    },

    sendOrder(payData) {
      console.log("send order");

      this.$store.state.order.payAmount = this.roundNumber(
        this.$store.state.order.total + this.$store.state.order.tips,
        2
      );

      if (payData != null) {
        this.$store.state.order.payData = payData;
      }

      this.sendOrderToServer()
        .then(data => {
          if (data.result == "ok") {
            this.navMenu();
          } else {
            this.setSendFailed();
          }
        })
        .catch(error => {
          console.log(error);
          this.setSendFailed(error);
        })
        .finally(() => {
          if (this.merchant == "stripe") {
            this.updateSaveCardStatus();

            this.stripe.confirmed = false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

.container {
  margin-bottom: 200px;
}

.pay-amount {
  text-align: center;
  font-size: 2em;
  color: black;
  background-color: transparent;
  margin: 0px;
  padding: 20px;
}

#iframeId {
  //set the height to 100% of the viewport less the height of the header
  height: 100vh; //calc(100vh - 200px);
  //height: calc(100vh + 200px);
  //height: 100%;

  //set the width to 100% of the viewport width
  //width: 100vw;
  width: 100%;

  //remove border, padding, margin
  border: none;
  padding: 0;
  margin: 0;
}

.card-form {
  width: 100;
  //width: 480px;
  //margin: 20px 0;
}

.card-group {
  //background: white;
  //box-shadow: 0 7px 14px 0 rgba(49, 49, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.08);
  //border-radius: 4px;
  //margin-bottom: 20px;
}
.card-item {
  position: relative;
  //color: #8898aa;
  //font-weight: 300;
  //height: 80px;
  //line-height: 40px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 8px 0px;

  .card-item-label {
    padding-left: 8px;
  }
}
.card-field {
  //background: transparent;
  font-weight: 300;
  border: 0;
  //color: #31325f;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
}
.card-field::-webkit-input-placeholder {
  color: #cfd7e0;
}
.card-field::-moz-placeholder {
  color: #cfd7e0;
}

.card-save {
  .card-save-message {
    font-size: 0.9em;
  }
}

/* .order-content {
  padding-top: 16px;
  .col {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .item-descr {
    white-space: pre-line !important;
  }

  .promo-descr {
    //color: var(--v-accent-base);
    font-weight: bold;
  }

  .item-barcode {
    font-size: 0.9em;
    color: var(--v-secondary-base);
  }

  .item-remark {
    font-size: 1em;
    color: var(--v-accent-base);
  }
}

.order-total {
  font-weight: bold;
}

.total-to-pay {
  font-weight: bold;
  color: var(--v-accent-base);

  .total-to-pay-currency {
    text-align: right;
    font-size: 0.8em;
    font-weight: normal;
  }
} */

.order-login-box {
  //padding: 20px 0px;

  .t-title {
    color: var(--v-accent-base);
    font-weight: bold;
  }
}

.order-paid-data-title {
  color: var(--v-accent-base);
  font-weight: bold;
}
.order-paid-data-value {
  font-size: 0.8em;
}

.stripe-save-card {
  margin-top: 0px;
}

.stripe-alipay {
  margin-top: 8px;
  margin-bottom: 8px;
}

.stripe-powered-by {
  margin-top: 8px;
}

.takeout-address-title {
  color: var(--v-accent-base);
  font-weight: bold;
}

.delivery-address-title {
  color: var(--v-accent-base);
  font-weight: bold;
}

.schedule-time-title {
  color: var(--v-accent-base);
  font-weight: bold;
}

.terms-of-use-box {
  padding-top: 12px;
  .accept-policy {
    //text-align: center;
    font-size: 0.8em;
    //padding: 0px 30px;
    padding-bottom: 10px;
  }

  .terms-of-use-text {
    color: var(--v-warning-base);
    font-weight: bold;
  }

  /*   .terms-of-use {
    //text-align: center;
    //padding-bottom: 20px;

    .terms-of-use-text {
      font-size: 0.5em;
      padding: 5px 10px;
      text-transform: uppercase;

      border-radius: 15px;
      //background-color: rgb(200, 200, 200);
      color: var(----v-accent-warning);
      font-weight: bold;
    }
  } */
}

.v-footer {
  padding: 0px;
  padding-bottom: calc(env(safe-area-inset-bottom));

  > div {
    width: 100%;
  }

  .merchant-info {
    text-align: center;
    font-size: 0.8em;
    padding: 10px 30px;

    .store-name {
      font-weight: bold;
    }
  }

  .accept-policy {
    text-align: center;
    font-size: 0.8em;
    padding: 0px 30px;
    padding-bottom: 10px;
  }

  .terms-of-use {
    text-align: center;
    padding-bottom: 20px;

    .terms-of-use-text {
      font-size: 0.5em;
      padding: 5px 10px;
      text-transform: uppercase;

      border-radius: 15px;
      background-color: rgb(200, 200, 200);
    }
  }

  .resend-button {
    color: black;
  }

  .send-failed-text {
    //white-space: pre-line;
    padding: 12px;
    margin-bottom: 2px;
    font-size: 0.9em;
    //text-align: center;
    background-color: var(--v-warning-base);
    color: var(--v-warningText-base);
  }

  .pay-failed-text {
    //white-space: pre-line;
    padding: 12px;
    margin-bottom: 2px;
    font-size: 0.9em;
    text-align: center;
    background-color: var(--v-warning-base);
    color: var(--v-warningText-base);
  }

  /*   #payButtonId {
    width: 100%;
    height: 36px;
    background-color: var(--v-info-base) !important;
    color: var(--v-infoText-base) !important;
  } */

  .confirm-button {
    width: 100%;
    height: 36px;
    background-color: var(--v-info-base) !important;
    color: var(--v-infoText-base) !important;
  }
}
</style>
